import React from "react"
import styled from "styled-components"

import { TextGroup, Button, Media, Link } from "components/common"

import { device } from "utils"

const FeaturedBlogPost = ({ title, subtitle, slug, cardImage }) => {
  return (
    <Link to={`/blog/${slug}`}>
      <StyledFeaturedBlogPost>
        <div className="left">
          <TextGroup
            hat="featured"
            title={title}
            titleAs="h3"
            subtitle={subtitle}
          />
          <Button className="readPost">Read Post</Button>
        </div>
        <div className="featuredImageWrap">
          <Media
            critical
            className="featuredImage"
            media={{ desktop: cardImage }}
          />
        </div>
      </StyledFeaturedBlogPost>
    </Link>
  )
}

const StyledFeaturedBlogPost = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: var(--sp-48);
  align-items: center;
  --tg-hat-color: var(--spruce);

  @media ${device.laptop} {
    grid-template-columns: min(50%, 470px) 1fr;

    &:hover {
      .featuredImageWrap {
        transform: scale(1.02);
      }

      .readPost {
        .button_arrow {
          transform: translateX(var(--sp-8));
        }
      }
    }
  }

  .left {
    text-align: left;

    @media ${device.laptop} {
      padding: var(--sp-32);
      padding-left: 0;
    }

    .readPost {
      margin-top: var(--sp-24);
    }
  }
  .featuredImageWrap {
    transition: 0.2s transform ease-in-out;
    will-change: transform;
    grid-row-start: 1;

    @media ${device.laptop} {
      grid-column-start: 2;
    }
    img {
      object-fit: cover !important;
      width: 100%;
      border-radius: var(--card-radius);
    }
  }
`

export default FeaturedBlogPost
